<div id="page-content">
  <aaos-header></aaos-header>
  <div *ngIf="isLoggedIn">
    <div *ngIf="dataIsLoaded">
      <div *ngIf="isAuthorized; then authorized else unauthorized"></div>
      <ng-template #authorized>
        <aaos-nav-bar></aaos-nav-bar>
        <main class="main" id="main">
          <router-outlet></router-outlet>
        </main>
      </ng-template>
      <ng-template #unauthorized>
        <aaos-app-unauthorized></aaos-app-unauthorized>
      </ng-template>
    </div>
    <aaos-footer></aaos-footer>
  </div>
</div>